import { ExportStatusObject } from '@/models/Interfaces';
import _ from 'lodash';
import { api } from './Api';

export default {
    authToken(): string | null {
        // return authorization header with jwt token
        const token = localStorage.getItem('yslp_token');
        if (token) return JSON.parse(token);
        return null;
    },
    generateString(length: number): string {
        let result = '';
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        const charactersLength = characters.length;
        for (let i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    },

    async waitForExportTaskSilent(
        Task: ExportStatusObject,
        onFinish: (url: string | null, error: string | null) => void,
        time: number = 3000
    ) {
        const resp = await api.ExportStatus(Task.Id);
        if (resp.Error || !resp.Data) {
            onFinish(null, resp.ErrorMessage);
            return;
        }
        const data = resp.Data;

        Task.State = data.State;

        if (data.State == 'Failed') {
            onFinish(null, null);
            return;
        } else if (data.State == 'Succeeded') {
            onFinish(data.ReportUrl, null);
            return;
        }

        if (time > 0) _.delay(() => this.waitForExportTaskSilent(Task, onFinish, time), time);
    },

    toSnakeCase(text: string) {
        return text
            .replace(/([a-z])([A-Z])/g, '$1_$2')
            .replace(/[\s\-]+/g, '_')
            .toLowerCase();
    },
};
